import { useState } from "react";
import { faqs } from "@/mocks/guaData";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="scroll-mt-28 bg-paper-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[0.9fr_1.6fr]">
          <div>
            <div className="mb-1 text-xs font-semibold tracking-[0.2em] text-primary-600">FAQ</div>
            <h2 className="font-serif text-2xl font-extrabold tracking-tight text-stone-900 md:text-3xl">常见问题</h2>
            <p className="mt-3 text-sm leading-relaxed text-stone-500">
              关于内容收录、信源核实与投稿方式，我们整理了一些高频疑问。没找到答案？欢迎通过页脚的邮箱与我们聊聊。
            </p>
            <a
              href="#subscribe"
              className="mt-5 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-paper-100 px-4 py-2 text-sm font-medium text-stone-700 transition hover:bg-primary-100 hover:text-primary-700"
            >
              <i className="ri-question-answer-line" />
              还有疑问，来联系我们
            </a>
          </div>

          <div className="divide-y divide-paper-200 rounded-lg border border-paper-200 bg-white">
            {faqs.map((f, i) => {
              const open = openIdx === i;
              return (
                <div key={f.q}>
                  <button
                    type="button"
                    onClick={() => setOpenIdx(open ? -1 : i)}
                    className="flex w-full cursor-pointer items-center justify-between gap-3 px-5 py-4 text-left"
                  >
                    <span className={`font-medium ${open ? "text-primary-700" : "text-stone-800"}`}>
                      <span className="mr-2 font-serif font-bold text-accent-500">Q{i + 1}</span>
                      {f.q}
                    </span>
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition ${
                      open ? "rotate-45 bg-primary-500 text-white" : "bg-paper-100 text-stone-500"
                    }`}>
                      <i className="ri-add-line" />
                    </span>
                  </button>
                  <div className={`grid transition-all duration-300 ${open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                    <div className="overflow-hidden">
                      <p className="px-5 pb-4 pl-12 text-sm leading-7 text-stone-600">{f.a}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}